import React from "react";
import PlusSvg from "../svg/PlusSvg";
const MoreUserBtn = ({ children }) => {
  return (
    <a href="/" className="more_user_btn">
      <span className="btn_icon">
        <PlusSvg />
      </span>
      {children}
    </a>
  );
};

export default MoreUserBtn;
